import React from "react";
import "./PopupModal.css";

const PopupModal = ({ children }) => (
  <div className="popup-modal">{children}</div>
);

export default PopupModal;
